<template>
  <div v-if="value" class="fixed top-0 left-0 right-0 bottom-0 z-50 bg-black bg-opacity-70 flex justify-center items-center p-4">
    <div class="bg-white text-center w-full max-w-[400px] p-4 rounded-lg">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseOverlay',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update'],
  model: {
    event: 'update',
  },
  methods: {
    show() {
      return new Promise((resolve) => {
        this.$emit('update', true)
        this.resolve = resolve
      })
    },
    close() {
      this.$emit('update', false)
      this.resolve(true)
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'tailwindcss/base' as base;
@use 'tailwindcss/components' as components;
@use 'tailwindcss/utilities' as utilities;

:root {
  --condition: #{isFundswapTrade};
}

@if not var(--condition) {
  base components utilities * {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #f5f5f5;
  }
}
</style>